import {useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setMessage} from "./app-slice";
import {useTranslate} from "./useTranslate";
import {getEffectivePermissions, resolveActiveWorkspaceUserRoles} from "./workspace-permissions";

export function usePermission() {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const graphMembership = useSelector((state) => state.workspaceGraph.workspaceMembership);
    const graphUserRoles = useSelector((state) => state.workspaceGraph.userRoles);
    const [scopeRolePermissions, setScopeRolePermissions] = useState([]);
    const [scopeId, setScopeId] = useState();
    const dispatch = useDispatch();
    const translate = useTranslate();
    const permissions = useMemo(
        () => {
            const userRoles = resolveActiveWorkspaceUserRoles(
                workspaceMembershipData,
                graphMembership,
                graphUserRoles,
            );
            return getEffectivePermissions(
                userRoles,
                scopeId,
                scopeRolePermissions,
                workspaceMembershipData?.workspace?.workspaceStatus || "active",
            );
        },
        [
            graphUserRoles,
            graphMembership,
            scopeId,
            scopeRolePermissions,
            workspaceMembershipData,
        ],
    );

    const can = (permission, message = false) => {
        if (!permission) return true;

        const hasPermission = permissions.includes("*") || permissions.includes(permission);
        if (!hasPermission && message) {
            dispatch(setMessage({severity: "warn", content: translate("no-permission")}));
        }

        return hasPermission;
    };

    return {can, permissions, setScopeId, setScopeRolePermissions};
}
